var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartBarSolid = function SvgChartBarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#445A64",
    d: "M13.125 2.929v15h5v-15zm1.25 1.25h2.5v12.5h-2.5zm-12.5 2.5v11.25h5V6.679zm1.25 1.25h2.5v8.75h-2.5zm4.375 2.5v7.5h5v-7.5zm1.25 1.25h2.5v5h-2.5z"
  })));
};
export default SvgChartBarSolid;